import React, { useState, useEffect } from 'react';
import { ApiURLs, imageBaseUrls } from '../../constant/ApiUrls';
import { fetchData, uploadImage, postData, updateData, deleteData } from '../../services/api';
import Paper from '@mui/material/Paper';
import Swal from 'sweetalert2';
import { DataGrid } from '@mui/x-data-grid';

import {
    Wrapper,
    Card
    , EditButton,

} from './about_us_styles';

import placeholderImage from "../../../src/components/assets/image/placeholder.png";

import AboutUsSection from './AboutUs';
import AddMember from './AddMember';

import AddFeature from './AddFeature';


const AboutUs = () => {
    const [aboutUs, setAboutUS] = useState(null);
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [editAboutUS, setEditAboutUS] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        image: null,
        image_uploaded: null,
    });
    const [formErrors, setFormErrors] = useState({});

    const [activeTab, setActiveTab] = useState('about');

    const getAboutUsData = async ({ load = true } = {}) => {
        if (load) {
            setLoading(true);
        }
        const url = `${ApiURLs.ABOUT}`;
        try {
            const response = await fetchData(url);
            if (response.status === 1 || response.status === 2) {
                setAboutUS(response);
                if (response.status === 2) {
                    setFormData({ title: '', description: '', image: null });
                }
                else {
                    setFormData({ title: response.data.title, description: response.data.description, image: null, image_uploaded: response.data.image });

                }

            } else {
                setAboutUS(null);
            }
        } catch (error) {
            console.error('Error fetching about us:', error);
            setAboutUS(null);
        } finally {
            setLoading(false);

        }
    };

    useEffect(() => {
        getAboutUsData();
    }, []);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
            setFormData({ ...formData, image: files[0] });
            setFormErrors({})
                ;
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("hdjhfdkjsjkdshkjfdhkjdhskjhfdshfkjdshfjsjhfh", aboutUs);



        if (aboutUs.status === 2) {

            const errors = {};
            if (!formData.image) {
                errors.image = 'Image is required';
            }
            if (!formData.title.trim()) {
                errors.title = 'Title is required';
            }
            if (!formData.description.trim()) {
                errors.description = 'Description is required';
            }

            if (Object.keys(errors).length > 0) {
                setFormErrors(errors);
                return;
            }

            setButtonLoading(true);

            console.log('Submit formData:', formData);

            const uploadedImage = await uploadImage(
                ApiURLs.UPLOAD_IMAGE,
                "image",
                formData.image,
                "about_us"
            );
            console.log(`Upload image function response: ${JSON.stringify(uploadedImage)}`);



            console.log('Submit formData:', formData);

            const data = {
                ...formData,
                image_uploaded: uploadedImage?.data?.file?.path || '',
            }
            console.log('DAATDATDTADA:::', data);

            await postData(data, `${ApiURLs.ABOUT}`);
            setButtonLoading(false);
            await getAboutUsData();

            setEditAboutUS(false);
        }
        else if (aboutUs.data.id) {

            console.log("hdjhfdkjsjkdshkjfdhkjdhskjhfdshfkjdshfjsjhfh");

            const errors = {};

            if (!formData.title.trim()) {
                errors.title = 'Title is required';
            }
            if (!formData.description.trim()) {
                errors.description = 'Description is required';
            }

            if (Object.keys(errors).length > 0) {
                setFormErrors(errors);
                return;
            }

            setButtonLoading(true);

            console.log('Submit formData:', formData);

            let uploadedImage;
            if (formData.image) {
                uploadedImage = await uploadImage(
                    ApiURLs.UPLOAD_IMAGE,
                    "image",
                    formData.image,
                    "about_us"
                );
            }

            console.log(`Upload image function response: ${JSON.stringify(uploadedImage)}`);



            console.log('Submit formData:', formData);

            const data = {
                ...formData,
            }

            if (uploadedImage) {

                data['image_uploaded'] = uploadedImage?.data?.file?.path || '';

            }


            console.log('DAATDATDTADA:::', data);

            await updateData(data, `${ApiURLs.ABOUT}/${aboutUs.data.id}`);
            setButtonLoading(false);
            await getAboutUsData();
            setEditAboutUS(false);
        }


    };

    const teamListingHeading = [
        {
            field: "id", headerName: "NO", width: 40,
            renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
        },

        {
            field: "image",
            headerName: "Image",
            width: 100,
            sortable: false,
            renderCell: (params) => (
                <img
                    src={params.value ? `${imageBaseUrls(params.value)}` : placeholderImage}
                    alt="Profile"
                    style={{ width: 60, height: 60, borderRadius: "10px" }}
                />
            ),
        },

        {
            field: "name", headerName: "Name", width: 200,
            // renderCell: (params) => params.value, 
        },

        {
            field: "role", headerName: "Role", width: 400,
            // renderCell: (params) => params.value, 
        },
        {
            field: "action",
            headerName: "Action",
            width: 300,
            sortable: false,
            renderCell: (params, row) => {
                console.log("veiw is called", params, row);


                return (
                    <div style={{
                        display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
                        height: "100%"
                    }}>
                        {/* <AddPlan
                            buttonLabel="Edit"
                            editMode={true}
                            planData={params.row}
                            categories={categories}

                        /> */}


                        <AddMember buttonLabel={"Edit Member"} editMode={true}
                            handleAddMember={handleEditMember}
                            memberData={params.row}

                        />



                        <button
                            onClick={() => handleDeleteM(params.row)}
                            style={{
                                backgroundColor: "#F44336",
                                color: "white",
                                border: "none",
                                cursor: "pointer",
                                borderRadius: "4px",
                                fontSize: "10px",
                                width: "30%",
                                height: "24px",  // Increased height
                                padding: "2px 5px", // Added padding
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            Delete
                        </button>


                    </div>

                );
            },
        },


    ];

    const paginationModel = { page: 0, pageSize: 10 };

    const handleDeleteM = (row) => {
        console.log("Deleting Team Mamber ID:", row);
        Swal.fire({
            title: ``,
            html:
                "" +
                "Are you sure?" +
                "<br>" +
                `You want to Delete "${row.name}"`,
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: `Yes, Delete`,
            showCloseButton: true,
            cancelButtonColor: "gray",
            confirmButtonColor: "#4f83df",
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                handleDeleteMember(row.id,)
            }
        });

        // Add your delete logic here
    };

    const handleAddMember = async (d) => {

        setLoading(true);
        console.log("Received data:", d);
        const uploadedImage = await uploadImage(
            ApiURLs.UPLOAD_IMAGE,
            "image",
            d.uploadImage,
            "members"
        );


        const data = {
            ...d,
            image: uploadedImage?.data?.file?.path || '',
            team_info_id: aboutUs.data.id,
        }
        console.log('DAATDATDTADA:::', data);

        await postData(data, `${ApiURLs.MEMBERS}`);

        await getAboutUsData();

    };


    const handleEditMember = async (d) => {

        setLoading(true);
        console.log("Received data:", d);
        let uploadedImage = null;


        if (d.uploadImage) {
            uploadedImage = await uploadImage(
                ApiURLs.UPLOAD_IMAGE,
                "image",
                d.uploadImage,
                "members"
            );
        }

        const data = {
            ...d,
        }

        if (uploadedImage) {
            data['image'] = uploadedImage?.data?.file?.path || '';

        }
        console.log('DAATDATDTADA:::', data);

        await updateData(data, `${ApiURLs.MEMBERS}/${data.id}`);

        await getAboutUsData();
    };


    const handleDeleteMember = async (id) => {

        setLoading(true);

        await deleteData(`${ApiURLs.MEMBERS}/${id}`);

        await getAboutUsData();

    };





    const featuresListingHeading = [
        {
            field: "id", headerName: "NO", width: 40,
            renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
        },

        {
            field: "icon",
            headerName: "Icon",
            width: 100,
            sortable: false,
            renderCell: (params) => (
                <img
                    src={params.value ? `${imageBaseUrls(params.value)}` : placeholderImage}
                    alt="Icon"
                    style={{ width: 60, height: 60, borderRadius: "10px" }}
                />
            ),
        },

        {
            field: "title", headerName: "Title", width: 200,
            // renderCell: (params) => params.value, 
        },

        {
            field: "description", headerName: "Description", width: 400,
            // renderCell: (params) => params.value, 
        },
        {
            field: "action",
            headerName: "Action",
            width: 300,
            sortable: false,
            renderCell: (params, row) => {
                console.log("veiw is called", params, row);


                return (
                    <div style={{
                        display: "flex", flexDirection: "row", gap: "4px", alignItems: "center",
                        height: "100%"
                    }}>


                        <AddFeature buttonLabel={"Edit Feature"} editMode={true}
                            handleAddFeature={handleEditFeature}
                            memberData={params.row}

                        />

                        <button
                            onClick={() => handleDeleteF(params.row)}
                            style={{
                                backgroundColor: "#F44336",
                                color: "white",
                                border: "none",
                                cursor: "pointer",
                                borderRadius: "4px",
                                fontSize: "10px",
                                width: "30%",
                                height: "24px",  // Increased height
                                padding: "2px 5px", // Added padding
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            Delete
                        </button>


                    </div>

                );
            },
        },


    ];


    const handleDeleteF = (row) => {
        console.log("Deleting Team Mamber ID:", row);
        Swal.fire({
            title: ``,
            html:
                "" +
                "Are you sure?" +
                "<br>" +
                `You want to Delete "${row.title}"`,
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: `Yes, Delete`,
            showCloseButton: true,
            cancelButtonColor: "gray",
            confirmButtonColor: "#4f83df",
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                handleDeleteFeature(row.id,)
            }
        });

        // Add your delete logic here
    };

    const handleAddFeature = async (d) => {

        setLoading(true);
        console.log("Received data:", d);
        const uploadedImage = await uploadImage(
            ApiURLs.UPLOAD_IMAGE,
            "image",
            d.uploadImage,
            "features"
        );


        const data = {
            ...d,
            icon: uploadedImage?.data?.file?.path || '',
            team_info_id: aboutUs.data.id,
        }

        console.log('DAATDATDTADA:::', data);

        await postData(data, `${ApiURLs.FEATURES}`);

        await getAboutUsData();

    };


    const handleEditFeature = async (d) => {

        setLoading(true);
        console.log("Received data:", d);
        let uploadedImage = null;


        if (d.uploadImage) {
            uploadedImage = await uploadImage(
                ApiURLs.UPLOAD_IMAGE,
                "image",
                d.uploadImage,
                "features"
            );
        }

        const data = {
            ...d,
        }

        if (uploadedImage) {
            data['icon'] = uploadedImage?.data?.file?.path || '';

        }
        console.log('DAATDATDTADA:::', data);

        await updateData(data, `${ApiURLs.FEATURES}/${data.id}`);

        await getAboutUsData();

    };


    const handleDeleteFeature = async (id) => {

        setLoading(true);

        await deleteData(`${ApiURLs.FEATURES}/${id}`);

        await getAboutUsData();

    };


















    return (
        <div>
            <div style={{ display: 'flex', gap: '16px', marginBottom: '20px' }}>
                <button
                    onClick={() => setActiveTab('about')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: activeTab === 'about' ? '#007bff' : '#eee',
                        color: activeTab === 'about' ? '#fff' : '#000',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    About Us
                </button>
                <button
                    onClick={() => setActiveTab('team')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: activeTab === 'team' ? '#007bff' : '#eee',
                        color: activeTab === 'team' ? '#fff' : '#000',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Team
                </button>
                <button
                    onClick={() => setActiveTab('feature')}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: activeTab === 'feature' ? '#007bff' : '#eee',
                        color: activeTab === 'feature' ? '#fff' : '#000',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Feature
                </button>
            </div>

            <Wrapper>
                <Card isFixedWidth={aboutUs?.status === 2} isPadding={activeTab === "about"}>

                    {activeTab === "about" && aboutUs?.status === 1 && loading === false && (
                        <EditButton onClick={() => setEditAboutUS(true)}>Edit</EditButton>
                    )}

                    {activeTab === "about" ? <AboutUsSection
                        loading={loading}
                        aboutUs={aboutUs}
                        editAboutUS={editAboutUS}
                        formData={formData}
                        formErrors={formErrors}
                        buttonLoading={buttonLoading}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                    /> : activeTab === "team" ? <Paper sx={{ height: "95%", width: '100%' }}>



                        {aboutUs?.data?.id && <div style={{ padding: "10px", justifyItems: "end" }}>
                            <AddMember buttonLabel={"Add Members"} handleAddMember={handleAddMember}
                            />
                        </div>}

                        <DataGrid
                            rows={aboutUs?.data?.teams || []}
                            columns={teamListingHeading || []}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[10, 25]}
                            rowHeight={80}
                            loading={loading}
                            checkboxSelection={false}
                            sx={{ border: 0 }}
                        />


                    </Paper>
                        : <Paper sx={{ height: "95%", width: '100%' }}>



                            {aboutUs?.data?.id && <div style={{ padding: "10px", justifyItems: "end" }}>
                                <AddFeature buttonLabel={"Add Feature"} handleAddFeature={handleAddFeature}
                                />
                            </div>}

                            <DataGrid
                                rows={aboutUs?.data?.features || []}
                                columns={featuresListingHeading || []}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[10, 25]}
                                rowHeight={80}
                                loading={loading}
                                checkboxSelection={false}
                                sx={{ border: 0 }}
                            />


                        </Paper>
                    }


                </Card>
            </Wrapper>
        </div>

    );
};



export default AboutUs;
